<template>
  <div class="create-job-profile-step1 d-flex flex-column h-100">
    <div class="step-header pa-6 pb-4">
      <div class="text-h6 text-textDarkest">
        Create Job Profile
      </div>
      <div class="text-body-2 text-textLight mt-1">
        Fill in the details below. Use the search to find similar profiles for reference.
      </div>
    </div>

    <v-divider class="opacity-100" />

    <div class="step-body flex-grow-1 overflow-hidden">
      <v-row
        no-gutters
        class="h-100"
      >
        <v-col
          cols="3"
          class="pa-6 d-flex flex-column ga-4 border-e"
        >
          <v-form
            ref="formRef"
            v-model="formValid"
          >
            <div class="d-flex flex-column ga-4">
              <DpplTextField
                v-model="formTitle"
                label="Job Profile Title"
                outlined
                :rules="titleRules"
                dense
              />
              <DpplTextField
                v-model="formJobCode"
                label="Job Code"
                outlined
                dense
              />
              <DpplTextField
                v-model="formLocation"
                label="Location"
                outlined
                dense
              />
            </div>
          </v-form>

          <v-spacer />

          <v-btn
            color="primary"
            variant="flat"
            rounded="lg"
            :disabled="!formValid"
            @click="onNext"
          >
            Next Step
          </v-btn>
        </v-col>

        <v-col
          cols="3"
          class="border-e overflow-y-auto h-100"
        >
          <div class="pa-4 pb-2 text-caption text-textLight text-uppercase font-weight-medium">
            Similar profiles
          </div>
          <ProfileSearchResults
            :results="store.searchResults"
            :loading="store.searchLoading"
            :selected-ulid="store.selectedProfileUlid"
            :has-searched="hasSearched"
            @select="store.selectProfileForPreview($event)"
          />
        </v-col>

        <v-col
          cols="6"
          class="overflow-y-auto h-100"
        >
          <WizardProfilePreview
            :profile="{
              ...store.previewProfile,
              title: formTitle,
              job_code: formJobCode,
              location: formLocation,
              is_hris_profile: false,
            }"
            :loading="store.previewLoading"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { debounce } from 'lodash-es';
import { storeToRefs } from 'pinia';
import { useCreateJobProfileWizard } from '@/stores/jobProfiles/createJobProfileWizard';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import validation from '@/helpers/validation';
import ProfileSearchResults from './ProfileSearchResults.vue';
import WizardProfilePreview from './WizardProfilePreview.vue';

const store = useCreateJobProfileWizard();
const { formTitle, formJobCode, formLocation } = storeToRefs(store);

const formRef = ref(null);
const formValid = ref(false);
const hasSearched = ref(false);

const titleRules = validation.titleRules();

const debouncedSearch = debounce(async () => {
  hasSearched.value = true;
  await store.searchProfiles();
}, 1000);

watch([formTitle, formJobCode], () => {
  debouncedSearch();
});

const onNext = async () => {
  const result = await formRef.value?.validate();
  if (result?.valid) {
    store.goToStep2();
  }
};
</script>
